import { useEffect, useState } from 'react'
import { StateCase } from '../../config/enums'
import { controlList } from './storage'
import { getCompanySelected } from '../../utilities/controlStorage'

export default function useInitial() {
    const [state, setState] = useState(StateCase.LOADING)

    useEffect(() => {
        const company = getCompanySelected()
        const country = company.country

        controlList.filter.setOption('country_id', {
            value: country.id.toString(),
            label: country.name,
            image: country.image_url
        })

        controlList.filter.changeParams('sort', 'name')

        controlList.done().then(result => {
            if (result) {
                setState(StateCase.SUCCESS)
            } else {
                setState(StateCase.ERROR)
            }
        })
    }, [])

    return state
}
